// Packages
import React, { useEffect } from "react";
import { FormattedMessage } from 'react-intl';
import { isStorefrontThemed } from "../../helpers/storefrontTheme";

interface IGeneralAnnouncementProps {
  onClose: () => void;
  announcement: string;
  brandColor: string;
}

function GeneralAnnouncement(props: IGeneralAnnouncementProps) {
  useEffect(() => {
    return () => {
      if (!isStorefrontThemed()) {
        document.querySelector('meta[name="theme-color"]').setAttribute("content", props.brandColor);
      }
    };
  }, []);

  return (
    <div className="general-announcement">
      <p className="announcement-message">
        {props.announcement}
      </p>
      <div className="close-button" onClick={() => props.onClose()}>
        <FormattedMessage
          id="global.close"
          defaultMessage="Close"
        />
      </div>
    </div>
  );
}
export default GeneralAnnouncement;
